export class ConstantsWebservice {
    static readonly GET_WS_RUBRIKEN: string             = '/rubriken';
    static readonly GET_WS_OBERBEGRIFFE: string         = '/oberbegriffe';
    static readonly GET_WS_REGIONEN: string             = '/regionen';
    static readonly GET_WS_BMEL_CODES: string           = '/bmel-codes';
    
    static readonly POST_WS_CSV_DATEN_INHALT: string    = '/csv-daten-inhalt';
    static readonly POST_WS_USER_BETRIEBSDATEN: string  = '/user-betriebsdaten';
    static readonly POST_WS_PDF_BETRIEBE: string        = '/pdf-betriebe';
    
    
}
